export default "__VITE_ASSET__B_4pwado__"